import { useEffect, useMemo, useState } from "react";

export default function useSidebarLogic(currentPath) {
  const peopleItems = useMemo(
    () => [
      {
        label: "Staff",
        path: "/admin/dashboard/staff",
        icon: "staff",
      },
      {
        label: "Miembros",
        path: "/admin/dashboard/members",
        icon: "members",
      },
    ],
    []
  );

  const membershipItems = useMemo(
    () => [
      {
        label: "Membresías",
        path: "/admin/dashboard/memberships",
        icon: "memberships",
      },
    ],
    []
  );

  const storeItems = useMemo(
    () => [
      {
        label: "Secciones",
        path: "/admin/dashboard/store-sections",
      },
      {
        label: "Categorías",
        path: "/admin/dashboard/store-categories",
      },
      {
        label: "Marcas",
        path: "/admin/dashboard/store-brands",
      },
      {
        label: "Productos",
        path: "/admin/dashboard/store-products",
      },
      {
        label: "Órdenes",
        path: "/admin/dashboard/store-orders",
      },
    ],
    []
  );

  const peopleActive = peopleItems.some(
    (item) => item.path === currentPath
  );

  const membershipsActive = membershipItems.some(
    (item) => item.path === currentPath
  );

  const storeActive = storeItems.some(
    (item) => item.path === currentPath
  );

  const [openSection, setOpenSection] = useState(
    peopleActive
      ? "people"
      : membershipsActive
      ? "memberships"
      : storeActive
      ? "store"
      : null
  );

  useEffect(() => {
    if (peopleActive) {
      setOpenSection("people");
      return;
    }

    if (membershipsActive) {
      setOpenSection("memberships");
      return;
    }

    if (storeActive) {
      setOpenSection("store");
      return;
    }

    setOpenSection(null);
  }, [peopleActive, membershipsActive, storeActive, currentPath]);

  const toggleSection = (section) => {
    setOpenSection((prev) => (prev === section ? null : section));
  };

  const isActive = (path) => currentPath === path;

  return {
    peopleItems,
    membershipItems,
    storeItems,
    openSection,
    toggleSection,
    isActive,
  };
}